<template>
  <v-container fluid style="height: 100%;" class="px-0 py-0 m-0 box" align-stretch>
    <v-layout row wrap ma-0 py-4>
      <v-flex class="col-12 pa-0 ma-0">
        <p class="font-weight-medium my-0 ml-4 pl-4">บริเวณที่เกิดเหตุ</p>
        <v-card
          class="d-flex justify-center ma-0 my-2 px-2"
          :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          flat
        >
          <v-flex
            class="col-3"
            v-for="(item, i) in roads"
            :key="i"
            :class="[
              { '': i != 0 && $vuetify.breakpoint.mdAndUp },
              { 'col-12 mb-4 pt-0 px-1': $vuetify.breakpoint.smAndDown }
            ]"
          >
          <v-card class="rectangle2">
            <v-layout>
              <v-flex xs12>
                <div class="pa-0 mt-3 px-2 title-area">
                  <v-layout ma-0 pb-2>
                    <v-flex xs2>
                      <v-img
                        class="sub-menu"
                        height="32"
                        width="32"
                        :src="getAreaImage(item.id)"
                      ></v-img>
                    </v-flex>
                    <v-flex xs6 ml-2>
                      <p class="font-weight-medium caption my-0">{{ item.name }}</p>
                      <p class="font-weight-light caption mb-0 grey-ligthen">
                        {{ item.percentage }}
                      </p>
                    </v-flex>
                    <v-flex xs4>
                      <p class="font-weight-medium my-0 title number text-right">
                        {{ item.accident | numFormat }} ครั้ง
                      </p>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="stat" ref="chartContainer">
                  <highcharts
                    class="charts"
                    ref="chart"
                    :options="getChartOptions(item.percentage, item.vehicle)"
                  ></highcharts>
                </div>

                <div class="pa-0 mt-3 px-2">
                  <p class="font-weight-medium caption my-0 pb-1 box">
                    ยานพาหนะ 3 อันดับสูงสุด (คัน)
                  </p>
                  <v-layout
                    ma-0
                    px-3
                    style="height:55px"
                    class="box"
                    v-for="(veh, i) in item.vehicle"
                    :key="i"
                  >
                    <v-flex xs9>
                      <p class="caption cause-area">{{ veh.name }}</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium subtitle-2 number cause-area cause-number">
                        {{ veh.amount | numFormat }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    ma-0
                    px-3
                    style="height:55px"
                    class="box"
                    v-show="item.vehicle.length == 0"
                  >
                    <v-flex xs9>
                      <p class="caption cause-area">ไม่พบข้อมูล</p>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="pa-0 mt-3 px-2">
                  <p class="font-weight-medium caption my-0 pt-3 pb-1 box">
                    สาเหตุ 3 อันดับสูงสุด (ครั้ง)
                  </p>
                  <v-layout
                    ma-0
                    px-3
                    style="height:55px"
                    class="box"
                    v-for="(cau, i) in item.cause"
                    :key="i"
                  >
                    <v-flex xs9>
                      <p class="caption cause-area">{{ cau.name }}</p>
                    </v-flex>
                    <v-flex xs3>
                      <p class="font-weight-medium subtitle-2 number cause-area cause-number">
                        {{ cau.amount | numFormat }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    ma-0
                    px-3
                    style="height:55px"
                    class="box"
                    v-show="item.cause.length == 0"
                  >
                    <v-flex xs9>
                      <p class="caption cause-area">ไม่พบข้อมูล</p>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Cause',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    title: 'มูลเหตุสันนิฐาน',
    colors: ['#f3a055', '#758f39', '#4f3f40', '#B57B0D'],
    roads: [],
    vehicles: [],
    causes: []
  }),
  created() {
    const scope = this;
    this.initData();
    this.roads = this.roads.map(item => {
      item.vehicles = scope.vehicles;
      item.causes = scope.causes;
      return item;
    });
    window.resizeAreaTimeOut = () => {
      if (window.resizeAreaChart) {
        clearTimeout(window.resizeAreaChart);
      }
      window.resizeAreaChart = setTimeout(() => {
        scope.$refs.chart.forEach((chart, i) => {
          // chart.chart.options.chart.width = scope.$refs.chartContainer.clientWidth;
          chart.chart.reflow();
        });
      }, 500);
    };
    window.addEventListener("resize", window.resizeAreaTimeOut);
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("resize", window.resizeAreaTimeOut);
  },
  methods: {
    initData() {
      const initSubRoad = {
        name: '--',
        amount: 0
      };
      const initRoad = {
        name: '--',
        accident: 0,
        dead: 0,
        injury: 0,
        cause: [initSubRoad],
        vehicle: [initSubRoad]
      };
      this.roads = [initRoad];
    },
    search() {
      if (this.searchCondition && this.searchCondition.isBMTA) {
        return;
      }
      const scope = this;
      this.initData();
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/area_by_order`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            const amount = data.reduce((sum, road) => sum + road.accident, 0);
            scope.roads = data.map(item => {
              item.cause.sort((a, b) => b.amount - a.amount);
              item.vehicle.sort((a, b) => b.amount - a.amount);
              item.percentage = `${((item.accident / amount) * 100).toFixed(2)}%`;
              return item;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      scope.$refs.chart.forEach((chart, i) => {
        // chart.chart.options.chart.width = scope.$refs.chartContainer.clientWidth;
        chart.chart.reflow();
      });
    },
    getChartOptions(percentage, vehicle) {
      const data = vehicle.map(item => [item.name, item.amount]);
      return {
        chart: {
          type: 'pie',
          renderTo: 'container',
        },
        title: {
          verticalAlign: 'middle',
          floating: false,
          text: percentage || 'ไม่พบข้อมูล'
        },
        plotOptions: {
          pie: {
            innerSize: '70%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: false,
            showInLegend: false
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">จำนวนยานพาหนะ</span><br/>',
          pointFormat: '{point.name}: <b>{point.y:,.0f} คัน</b>'
        },
        series: [
          {
            data
          }
        ],
        lang: {
            noData: percentage ? '' : 'ไม่พบข้อมูล'
        },
      };
    },
    getAreaImage(id) {
      try {
        return require(`@/assets/dashboard_icons/area_${id}.svg`);
      } catch (e) {
        try {
          return require(`@/assets/dashboard_icons/area_${element.id}.png`);
        } catch (e) {
          return require('@/assets/icons/other_location.svg');
        }
      }
    }
  },
  computed: {},
  watch: {
    searchCondition() {
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle {
  width: 100%;
  min-height: 600px;
  height: 100%;
  border-radius: 3px;
  border: solid 1px #979797;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 260px;
}

.title-area {
  height: 95px;
  border-bottom: solid 1px #979797;
}

.cause-area {
  height: 55px;
  vertical-align: middle;
  display: table-cell;
  width: 100%;
}

.cause-number {
  float: right;
  line-height: 55px !important;
  text-align: right;
}

.box {
  padding-left: 8px;
  padding-right: 8px;
  border-bottom: solid 1px #cccccc;
}
</style>
